import { render, staticRenderFns } from "./TwoSidesSwitch.vue?vue&type=template&id=69d6e99a&scoped=true&"
import script from "./TwoSidesSwitch.vue?vue&type=script&lang=js&"
export * from "./TwoSidesSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TwoSidesSwitch.vue?vue&type=style&index=0&id=69d6e99a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d6e99a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VRow,VSwitch})
